<template>
    <div :id="id" class="cursus-collapse" :class="classes">
        <template v-if="$slots.button">
            <div class="cursus-collapse__header">
                <div class="cursus-collapse__btn-wrapper" :class="buttonWrapperClasses">
                    <a class="btn cursus-collapse__btn px-print-0"
                        :class="buttonClasses"
                        :href="`#${id}`"
                        :tabindex="disabled ? -1 : 0"
                        @click.prevent="handleButtonClicked"
                    >
                        <span class="row align-items-center mx-n2">
                            <span class="col px-2">
                               <slot name="button" />
                            </span>
                            <template v-if="!disabled">
                                <span class="col-auto d-print-none px-2">
                                    <Icon name="arrow-down"
                                        class="cursus-collapse__arrow align-baseline"
                                        width=".75em"
                                        height=".75em"
                                    />
                                    <svg class="cursus-collapse__close align-baseline" width=".75em" height=".75em" style="display: none" viewBox="0 0 24 24">
                                        <path fill="none" stroke="currentColor" stroke-width="2.5" d="M3 3l18 18M3 21L21 3"/>
                                    </svg>
                                </span>
                            </template>
                        </span>
                    </a>
                </div>
            </div>
        </template>
        <div class="cursus-collapse__body" :class="bodyClass">
            <b-collapse class="d-print-block" v-model="opened">
                <slot />
            </b-collapse>
        </div>
    </div>
</template>

<script>
    import { BCollapse } from 'bootstrap-vue';
    import Icon from "./Icon";

    export default {
        components: {
            Icon,
            BCollapse
        },
        props: {
            id: {
                type: String,
                default: '',
            },
            visible: Boolean,
            btnClass: String,
            bodyClass: String,
            disabled: Boolean,
        },
        data() {
            return {
                opened: this.visible || this.disabled || location.hash === `#${this.id}`,
            }
        },
        computed: {
            classes() {
                return {
                    'cursus-collapse--opened': this.opened,
                    'cursus-collapse--disabled': this.disabled,
                    'cursus-collapse--default-button': !this.btnClass,
                }
            },
            buttonClasses() {
                return [
                    this.btnClass,
                    this.opened ? 'not-collapsed' : 'collapsed',
                    {
                        'cursus-collapse__btn--default': !this.btnClass,
                    }
                ];
            },
            buttonWrapperClasses() {
                return {
                    'cursus-collapse__btn-wrapper--default': !this.btnClass,
                }
            },
        },
        methods: {
            handleButtonClicked() {
                if(!this.disabled) {
                    this.opened = !this.opened;
                }
            }
        },
        mounted() {
            if(this.id && location.hash === `#${this.id}`) {
                window.scrollBy({ top:this.$el.getBoundingClientRect().top - 200 });
            }
        },
    }
</script>
